import { render, staticRenderFns } from "./table-1.vue?vue&type=template&id=3abb4d74&scoped=true"
import script from "./table-1.vue?vue&type=script&lang=js"
export * from "./table-1.vue?vue&type=script&lang=js"
import style0 from "./table-1.vue?vue&type=style&index=0&id=3abb4d74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abb4d74",
  null
  
)

export default component.exports